import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "../../assets/css/companyInformation.css";
import moment from "moment";
import api from "../../api/axios";
import { companyID } from "../../auth";
import config from "../../config";
import Breadcrumbs from "../Breadcrumbs";
import ProfileTab from "./CompanyProfile";

const CompanyInformation = () => {
  const [companyData, setCompanyData] = useState(null);
  const company_id = companyID();

  const parseAddress = (addressStr) => {
    const parts = addressStr.split(",");
    const trimmed = parts.map((p) => p.trim());
    return {
      address: trimmed.slice(0, trimmed.length - 4).join(", "),
      city: trimmed[trimmed.length - 4] || "",
      state: trimmed[trimmed.length - 3] || "",
      pincode: trimmed[trimmed.length - 2] || "",
      country: trimmed[trimmed.length - 1] || "",
    };
  };

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const res = await api.get(`api/company-details/${company_id}`);
        const data = res.data;
        data.date_of_incorporation = moment(data.date_of_incorporation).format(
          "YYYY-MM-DD"
        );
        setCompanyData(data);
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    };

    if (company_id) {
      fetchCompanyDetails();
    }
  }, []);

  if (!companyData || Object.keys(companyData).length === 0) {
    return null;
  }

  const address = companyData.additional_information.find(
    (info) => info.type === "address"
  );
  const current = parseAddress(address?.information_one || "");
  const permanent = parseAddress(address?.information_two || "");

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Breadcrumbs
          maintitle="Company Information"
          title="Dashboard"
          subtitle="Company"
        />

        {companyData && (
          <>
            <div className="card mb-0">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="profile-view">
                      {companyData.company_logo && (
                        <div className="company-img-wrap">
                          <div className="company-img">
                            <img
                              src={`${config.IMAGE_URL}${companyData.company_logo}`}
                              alt="Company Logo"
                              className="company-img"
                            />
                          </div>
                        </div>
                      )}

                      <div className="profile-basic">
                        <div className="row">
                          <div className="col-md-5">
                            <div className="profile-info-left">
                              {companyData.company_name && (
                                <h3 className="m-t-0 mb-0">
                                  {companyData.company_name}
                                </h3>
                              )}
                              {companyData.company_type && (
                                <h6 className="text-muted mb-1">
                                  {companyData.company_type}
                                </h6>
                              )}
                              {companyData.date_of_incorporation && (
                                <h6 className="text-muted">
                                  <strong className="text-dark pe-2">
                                    Date of Incorporation:
                                  </strong>
                                  {companyData.date_of_incorporation}
                                </h6>
                              )}
                            </div>
                          </div>

                          {(companyData.email || companyData.phone) && (
                            <div className="col-md-7">
                              <ul className="personal-info">
                                {companyData.email && (
                                  <li>
                                    <div className="title w-25">Email:</div>
                                    <div className="text">
                                      {companyData.email}
                                    </div>
                                  </li>
                                )}
                                {companyData.phone && (
                                  <li>
                                    <div className="title w-25">Phone:</div>
                                    <div className="text">
                                      {companyData.phone}
                                    </div>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Tabs
              defaultActiveKey="profile"
              className="mb-4 bg-light nav-tabs underline"
            >
              <Tab eventKey="profile" title="Profile">
                <ProfileTab
                  companyData={companyData}
                  current={current}
                  permanent={permanent}
                />
              </Tab>
            </Tabs>
          </>
        )}
      </div>
    </div>
  );
};

export default CompanyInformation;
